import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { restoreAll } from '../restoreAll';
import { RootState } from '..';
import { PublicPolicyDto } from '../../commonTypes/organization.types';

export interface OrganizationPolicies {
    value: PublicPolicyDto[];
}

const initialState: OrganizationPolicies = {
    value: [],
};

const organizationPoliciesSlice = createSlice({
    name: 'organizationPolicies',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        addOrganizationPolicies: (state, action: PayloadAction<PublicPolicyDto[]>) => {
            state.value = action.payload;
        },
    },
});

export const { addOrganizationPolicies } = organizationPoliciesSlice.actions;

export const selectOrganizationPolicies = (state: RootState) => state.organizationPolicies.value;

export default organizationPoliciesSlice.reducer;
